import React, { type FC } from "react";
import LineItemMismatchTableRenderComponent from "src/components/Pages/DocumentInbound/Tabs/Validations/ValidationsModals/Mismatch/LineItem/LineItemMismatchTableRenderComponent";
import MismatchTableRenderComponent from "src/components/Pages/DocumentInbound/Tabs/Validations/ValidationsModals/Mismatch/MismatchTableRenderComponent";
import { ViewUserActionMetadataEntry } from "src/components/UserActions/Handlers/Validation/types";
import {
  type UserAction,
  ValidationUserActionType,
} from "src/components/UserActions/types";
import type { ValidationUserActionsDropdownProps } from "src/components/UserActions/ValidationUserActionsDropdown";

export interface ValidationModalRenderComponentProps {
  readonly userAction?: UserAction;
  readonly validationGroupId: string;
  readonly validationUserActionsDropdownProps?: ValidationUserActionsDropdownProps;
}

const VIEW_RENDER_COMPONENT_BY_ATTRIBUTE = new Map<
  ViewUserActionMetadataEntry,
  FC<ValidationModalRenderComponentProps>
>()
  .set(ViewUserActionMetadataEntry.Default, MismatchTableRenderComponent)
  .set(
    ViewUserActionMetadataEntry.LineItemMismatch,
    LineItemMismatchTableRenderComponent
  );

const ValidationModalRenderComponent: FC<
  ValidationModalRenderComponentProps
> = ({ userAction, validationGroupId, validationUserActionsDropdownProps }) => {
  const mappedComponent =
    userAction?.type === ValidationUserActionType.VIEW &&
    VIEW_RENDER_COMPONENT_BY_ATTRIBUTE.get(userAction?.metadata?.attribute);

  const RenderComponent = mappedComponent || MismatchTableRenderComponent;

  return (
    <RenderComponent
      validationGroupId={validationGroupId}
      userAction={userAction}
      validationUserActionsDropdownProps={validationUserActionsDropdownProps}
    />
  );
};

export default ValidationModalRenderComponent;
